import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";

class AffiliateCompanyEndpoint {
  public list(params: AxiosRequestConfig = {}) {
    return $api.get("manager/affiliates", params);
  }

  public transactions(params: AxiosRequestConfig = {}) {
    return $api.get(`manager/affiliates/transactions`, params);
  }

  public complianceTrackings(params: AxiosRequestConfig = {}) {
    return $api.get(`manager/affiliates/compliance-trackings`, params);
  }

  public bankAccounts(
    company_id: number | string,
    params: AxiosRequestConfig = {}
  ) {
    return $api.get(`manager/affiliates/${company_id}/accounts`, params);
  }
}

export default AffiliateCompanyEndpoint;
